import { message } from "antd";
import { verifyStock } from "../../../services";
import messages from "../../../errors/messages.en-IN.json";
import useAdvanceOrderStore from "../../../stores/useAdvanceOrderStore";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";

const sproutz_url = process.env.REACT_APP_SPROUTZ_VERIFYSTOCK;

export const stock = async (props) => {
  const {
    cart,
    setCart,
    tillData,
    setProductStock,
    isFinalValidation,
    setTempCart,
    isCompleteSale,
    setShowCompleteSaleStock,
    setCompleteSaleStockData,
    customMixHandler = false,
    setProductBOMStock = () => {},
    setProductBOMStockData = () => {},
  } = props;
  const consolidateCart = (cart) => {
    const flatItems = [];

    cart.items.forEach((item) => {
      if (item.productSegment === "CB") {
        if (Array.isArray(item.childItems) && item.childItems.length > 0) {
          item.childItems.forEach((child) => {
            flatItems.push({
              ...child,
              parentLineId: item.lineId,
              type: child?.type,
              weight: child.weight,
              mBatchId: child.mBatchId || null,
              csBunitId: item.csBunitId || null,
              cwrPcatalogueId: item.cwrPcatalogueId || null,
            });
          });
        }
      } else if (Array.isArray(item.addons) && item.addons.length > 0) {
        item.addons.forEach((addon) => {
          flatItems.push({
            ...addon,
            parentLineId: item.lineId,
            type: "I",
            weight: addon.qty,
            mBatchId: addon.mBatchId || null,
            csBunitId: item.csBunitId || null,
            cwrPcatalogueId: item.cwrPcatalogueId || null,
          });
        });
      } else if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((child) => {
          flatItems.push({ ...child, parentLineId: item.lineId }); // Track parent
        });
      } else {
        flatItems.push(item);
      }
    });
    const consolidatedItems = flatItems.map((item) => ({
      ...item,
      weight: Number(item.weight || 0),
    }));
    return { ...cart, items: consolidatedItems };
  };
  const getProductNameById = (productId) => {
    for (const item of cart.items) {
      if (item.value === productId) {
        return item.name || "";
      }

      if (Array.isArray(item.children)) {
        for (const child of item.children) {
          if (child.value === productId) {
            return child.name || " ";
          }
        }
      }

      if (Array.isArray(item.childItems)) {
        for (const child of item.childItems) {
          if (child.value === productId) {
            return child.name || " ";
          }
        }
      }

      if (Array.isArray(item.addons)) {
        for (const addon of item.addons) {
          if (addon.value === productId) return addon.name || "";
        }
      }
    }
    return " ";
  };

  const cleanedCart = consolidateCart(cart);
  const consolidatedCartItems = new Map();

  cleanedCart.items.forEach((item) => {
    const { value, weight, mBatchId, csBunitId, cwrPcatalogueId, alternateUom, uom, uomData } = item;

    let calculatedQty = Number(weight || 0);

    const selectedAlternateUom = Array.isArray(alternateUom) ? alternateUom.find((altUom) => altUom?.csUomId && uom && altUom.csUomId === uom) : null;

    if (selectedAlternateUom) {
      const conversionRate = Number(selectedAlternateUom?.convertionRate ?? 1);

      const matchedUomData = Array.isArray(uomData) ? uomData.find((uomItem) => uomItem?.csUomId === uom) : null;

      // const stdprecision = Number(matchedUomData?.stdprecision ?? 3);

      calculatedQty = Number(weight || 0) * (Number.isNaN(conversionRate) ? 1 : conversionRate);

      calculatedQty = Number(calculatedQty.toFixed(3));
    }

    const uniqueKey = `${value}_${mBatchId}`;

    if (consolidatedCartItems.has(uniqueKey)) {
      const existingItem = consolidatedCartItems.get(uniqueKey);

      existingItem.orderQty = Number(existingItem.orderQty || 0) + calculatedQty;

      consolidatedCartItems.set(uniqueKey, existingItem);
    } else {
      consolidatedCartItems.set(uniqueKey, {
        productId: value,
        mBatchId,
        orderQty: calculatedQty,
        csBunitId,
        cwrPcatalogueId,
      });
    }
  });

  const buildCartProducts = Array.from(consolidatedCartItems.values())
    .map(({ productId, orderQty, mBatchId, csBunitId, cwrPcatalogueId }) => {
      if (sproutz_url === "true") {
        return `{ productId: "${productId}",,mBatchId: ${mBatchId ? `"${mBatchId}"` : null}, orderQty: ${orderQty}, cSBunitID: ${
          csBunitId ? `"${csBunitId}"` : null
        }, catalogueId: ${cwrPcatalogueId ? `"${cwrPcatalogueId}"` : null} }`;
      } else {
        return `{ productId: "${productId}",,mBatchId: ${mBatchId ? `"${mBatchId}"` : null}, orderQty: ${orderQty}, cSBunitID: ${csBunitId ? `"${csBunitId}"` : null} }`;
      }
    })
    .join(", ");
  const data = {
    query:
      sproutz_url === "true"
        ? `
        query { 
          verifyStock1(order: {
            orderNo: "${cart.documentno}"
            tillId: "${tillData.tillAccess.cwrTill.searchKey}"
            cartItems: [${buildCartProducts}]
          }) {
            orderNo
            tillId
            cartItems {
              productId
              orderQty
              mBatchId
              availabilityStatus
              availableQty
              billOfMaterials{
                value
                qtyOnHand
              }
            }
          }
        }
      `
        : `
        query { 
          verifyStock(order: {
            orderNo: "${cart.documentno}"
            tillId: "${tillData.tillAccess.cwrTill.searchKey}"
            cartItems: [${buildCartProducts}]
          }) {
            orderNo
            tillId
            cartItems {
              productId
              orderQty
              mBatchId
              availabilityStatus
              availableQty
              billOfMaterials{
                value
                qtyOnHand
              }
            }
          }
        }
      `,
  };
  try {
    const isAdvanceOrderEnabled = useAdvanceOrderStore.getState().isAdvanceOrderEnabled;
    if (isAdvanceOrderEnabled) {
      return true;
    }
    const response = await verifyStock(data);
    if (response?.status === 200) {
      const { cartItems } = sproutz_url === "true" ? response.data.data.verifyStock1 : response.data.data.verifyStock;
      const posConfig = usePOSConfigStore.getState().posConfig || JSON.parse(localStorage.getItem("posConfig"));
      let totalFlag = true;
      const updateCartItems = (item) => {
        const resItem = cartItems.find((resItem) => resItem.productId === item.value && (item.mBatchId ? resItem.mBatchId === item.mBatchId : true));
        if (!resItem) return item;
        let cappedWeight = item.weight;
        if (resItem.availabilityStatus !== "Yes" && resItem.availableQty < item.weight) {
          totalFlag = false;
          if (resItem.availableQty > 0) {
            cappedWeight = resItem.availableQty;
          }
        } else if (resItem.availabilityStatus !== "Yes") {
          resItem.availableQty -= item.weight;
        }
        const updated = {
          ...item,
          availabilityStatus: resItem.availabilityStatus,
          availableQty: resItem.availableQty,
        };
        if (cappedWeight !== item.weight) {
          const unitPrice = Number(item.sunitprice) || Number(item.salePrice) || 0;
          const taxRate = item.taxRate || 0;
          const taxIncFlag = posConfig?.taxIncludeFlag !== "N";
          const unitTax = taxIncFlag ? unitPrice - unitPrice / (1 + taxRate / 100) : (unitPrice * taxRate) / 100;
          updated.weight = cappedWeight;
          updated.nettotal = taxIncFlag ? cappedWeight * unitPrice : cappedWeight * (unitPrice + unitTax);
          updated.taxAmount = unitTax * cappedWeight;
        }
        return updated;
      };
      if (isFinalValidation) {
        const updatedCartData = cart.items.map(updateCartItems);
        const updatedCartItems = [];

        const groupedByParent = {};

        updatedCartData.forEach((item) => {
          if (item.childrenId) {
            if (!groupedByParent[item.childrenId]) {
              groupedByParent[item.childrenId] = [];
            }
            groupedByParent[item.childrenId].push(item);
          } else {
            updatedCartItems.push(item); // normal item
          }
        });

        // Merge children back into their parent items
        cart.items.forEach((originalItem) => {
          const lineId = originalItem.lineId;
          if (groupedByParent[lineId]) {
            updatedCartItems.push({
              ...originalItem,
              children: groupedByParent[lineId],
            });
          } else if (originalItem.productSegment === "CB" && Array.isArray(originalItem.childItems)) {
            const updatedChildren = originalItem.childItems.map((child) => {
              return updatedCartData.find((item) => item.value === child.value && (child.mBatchId ? item.mBatchId === child.mBatchId : true)) || child;
            });

            updatedCartItems.push({
              ...originalItem,
              childItems: updatedChildren,
            });
          }
        });
        const updatedCart = { ...cart, items: updatedCartData };
        setCart(updatedCart);
        setTempCart(JSON.parse(JSON.stringify(updatedCart)));
        return totalFlag;
      } else {
        const getCalculatedQty = (item) => {
          const { weight, alternateUom, uom, uomData } = item;

          let calculatedQty = Number(weight || 0);

          const selectedAlternateUom = Array.isArray(alternateUom) ? alternateUom.find((altUom) => altUom?.csUomId && uom && altUom.csUomId === uom) : null;

          if (selectedAlternateUom) {
            const conversionRate = Number(selectedAlternateUom?.convertionRate ?? 1);

            const matchedUomData = Array.isArray(uomData) ? uomData.find((uomItem) => uomItem?.csUomId === uom) : null;

            // const stdprecision = Number(matchedUomData?.stdprecision ?? 3);

            calculatedQty = Number(weight || 0) * (Number.isNaN(conversionRate) ? 1 : conversionRate);

            calculatedQty = Number(calculatedQty.toFixed(3));
          }

          return calculatedQty;
        };

        // Collect per-item stock failures instead of just a boolean
        const failedStockItems = [];
        cleanedCart.items.forEach((item) => {
          // Detector must match the same items the add-to-cart gate lets through (cart.js: type === "I" || !type).
          // Items with a blank/undefined type were being stock-checked but never flagged here, so a shortage
          // slipped through and the item was added anyway. Service items ("S") stay excluded.
          const resItem = cartItems.find((resItem) => resItem?.productId === item?.value && (item?.type === "I" || item?.type === "FGS" || !item?.type) && (item.mBatchId ? resItem.mBatchId === item.mBatchId : true));
          if (resItem && resItem.availabilityStatus !== "Yes") {
            const calculatedQty = getCalculatedQty(item);
            if (resItem.availableQty < calculatedQty) {
              failedStockItems.push({
                productId: item.value || item.productId || item.mProductId,
                name: item.name || getProductNameById(item.value),
                requestedQty: calculatedQty,
                availableQty: Number(resItem.availableQty) || 0,
                mBatchId: item.mBatchId || null,
              });
            }
            resItem.availableQty -= calculatedQty;
          }
        });

        const hasInsufficientStock = failedStockItems.length > 0;

        if (hasInsufficientStock && tillData.tillAccess.csBunit.allowNegativeStock === "N") {
          if (customMixHandler) {
            // Return detailed failure info for custom mix to show specific product names
            return { passed: false, failedItems: failedStockItems };
          }
          if (isCompleteSale) {
            const stockDetails = cartItems.map((item) => ({
              ...item,
              name: getProductNameById(item.productId),
            }));
            setCompleteSaleStockData(stockDetails);
            setShowCompleteSaleStock(true);
          } else {
            const stockDetails = posConfig?.requireBomStock === "Y" ? cartItems.filter((item) => item.billOfMaterials && item.billOfMaterials.length > 0) : [];
            setProductBOMStockData(stockDetails);
            if (posConfig?.requireBomStock === "Y" && stockDetails.length > 0) {
              setProductBOMStock(true);
            } else {
              setProductBOMStock(false);
              setProductStock(true);
            }
          }
          return false;
        }
      }
      return true;
    } else {
      message.error(messages.errors.orders.retrieve_stock_error);
      return false;
    }
  } catch (error) {
    console.error("Error checking stock:", error);
    message.error(messages.errors.orders.retrieve_stock_error);
    return false;
  }
};
